import { render, staticRenderFns } from "./SiteInfoLayout.vue?vue&type=template&id=e56f599a&"
import script from "./SiteInfoLayout.vue?vue&type=script&lang=js&"
export * from "./SiteInfoLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports